import Bowser from "bowser";

export const clientEnvIsIOS = () => {
  return Bowser.getParser(window.navigator.userAgent).getOSName(true) === "ios";
};
